<template>
    <main class="page">
        <section class="hero">
            <div class="hero__container-banner">
                <div class="hero__body">
                    <swiper :modules="modules" :observer="true" :observeParents="true" :speed="800" :slides-per-view="1" :pagination="{ clickable: true }" :autoplay="{ delay: 3000 }" class="hero__slider">
                        <swiper-slide v-for="(banner, index) in banners.banners" :key="index" class="hero__slide-ibg">
                            <router-link :to="{ name: 'Catalog', params: { categoryId: banner.url } }">
                                <img :src="$uploadUrl + banner.downloads[0].path" alt="banner_2_17_2_24.webp" class="desktop-only" />
                                <img :src="$uploadUrl + banner.downloads[1].path" alt="banner_2_17_2_24_mob.webp" class="mobile-only" />
                            </router-link>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </section>

        <!-- <section class="categories">
            <div class="categories__container">
                <div class="categories__body">
                    <div class="categories__head">
                        <div class="categories__title">ПРИКРАСИ ДЛЯ ІДЕАЛЬНОГО МОМЕНТУ</div>
                        <ul class="categories__list">
                            <li v-for="category in categories" :key="category.id" :class="['categories__item', { active: activeCategoryId === category.id }]" @click="setActiveCategory(category.id)">
                                {{ category.name }}
                            </li>
                        </ul>
                    </div>
                    <div class="categories__products">
                        <ProductSlider :title="activeCategoryName" :slug="'new-collection'" :categoryId="activeCategoryId" :id="99" />
                    </div>
                </div>
            </div>
        </section> -->
        <ProductSlider :title="'New Collection'" :slug="'new-collection'" :categoryId="1" :id="1" />

        <section class="advantages">
            <div class="advantages__container">
                <swiper
                    class="advantages__list"
                    :modules="modules"
                    :observer="true"
                    :observeParents="true"
                    :speed="300"
                    :autoplay="{ delay: 3000 }"
                    :scrollbar="{
                        draggable: true,
                    }"
                    :mousewheel="{
                        forceToAxis: true,
                    }"
                    :navigation="{
                        prevEl: '.reviews__navigation .btn-prev',
                        nextEl: '.reviews__navigation .btn-next',
                    }"
                    :breakpoints="swiperAdvantages.breakpoints"
                >
                    <swiper-slide class="advantages__item">
                        <div class="advantages__image-wrapper">
                            <img src="../assets/img/advantages/01.svg" alt="01.svg" />
                        </div>

                        <div class="advantages__content">
                            <div class="advantages__title">
                                <p>Доставка</p>
                            </div>
                            <div class="advantages__description">Самовивіз із м. Чернівці, доставка за адресою або у відділення "Нова Пошта", Укр Пошта та Міжнародна доставка.</div>
                        </div>
                    </swiper-slide>

                    <swiper-slide class="advantages__item">
                        <div class="advantages__image-wrapper">
                            <img src="../assets/img/advantages/02.svg" alt="02.svg" />
                        </div>
                        <div class="advantages__content">
                            <div class="advantages__title">
                                <p>Якісні Матеріали</p>
                            </div>
                            <div class="advantages__description">Використовуємо тільки якісну фурнітуру та каміння.</div>
                        </div>
                    </swiper-slide>
                    >
                    <swiper-slide class="advantages__item">
                        <div class="advantages__image-wrapper">
                            <img src="../assets/img/advantages/03.svg" alt="03.svg" />
                        </div>
                        <div class="advantages__content">
                            <div class="advantages__title">
                                <p>Оплата</p>
                            </div>
                            <div class="advantages__description">Оплатити покупку можливо платіжними системами, картою чи безготівковим розрахунком.</div>
                        </div>
                    </swiper-slide>
                    >
                    <swiper-slide class="advantages__item">
                        <div class="advantages__image-wrapper">
                            <img src="../assets/img/advantages/04.svg" alt="04.svg" />
                        </div>
                        <div class="advantages__content">
                            <div class="advantages__title">
                                <p>Повернення</p>
                            </div>
                            <div class="advantages__description">Повернення товару відбувається протягом 14 днів після покупки, у відповідності із діючим законом.</div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </section>

        <ProductSlider :title="'Кольє'" :slug="'new-collection'" :categoryId="2" :id="1" />
        <section class="reviews">
            <div class="reviews__container">
                <div class="reviews__top top-block">
                    <h2 class="top-block__title">ВІДГУКИ ВІД КЛІЄНТІВ</h2>
                    <div class="reviews__navigation navigation navigation_slider">
                        <button class="navigation__btn btn-prev"></button>
                        <button class="navigation__btn btn-next"></button>
                    </div>
                </div>
                <swiper
                    class="reviews-slider"
                    :modules="modules"
                    :observer="true"
                    :observeParents="true"
                    :speed="300"
                    :autoplay="{ delay: 3000 }"
                    :scrollbar="{
                        draggable: true,
                    }"
                    :mousewheel="{
                        forceToAxis: true,
                    }"
                    :navigation="{
                        prevEl: '.reviews__navigation .btn-prev',
                        nextEl: '.reviews__navigation .btn-next',
                    }"
                    :breakpoints="swiperReviews.breakpoints"
                >
                    <swiper-slide>
                        <img src="../assets/img/reviews/001.webp" alt="001.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/002.webp" alt="002.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/003.webp" alt="003.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/004.webp" alt="004.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/005.webp" alt="005.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/006.webp" alt="006.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/007.webp" alt="007.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/008.webp" alt="008.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/009.webp" alt="009.webp" />
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/img/reviews/0010.webp" alt="0010.webp" />
                    </swiper-slide>
                </swiper>
            </div>
        </section>
        <ProductSlider :title="'Сережки'" :slug="'new-collection'" :categoryId="3" :id="1" />
        <ProductSlider :title="'браслети'" :slug="'new-collection'" :categoryId="4" :id="1" />
        <ProductSlider :title="'каблучки'" :slug="'new-collection'" :categoryId="5" :id="1" />
        <ProductSlider :title="'анклет'" :slug="'new-collection'" :categoryId="6" :id="1" />

        <section class="about">
            <div class="about__container">
                <div class="about__top top-block">
                    <h2 class="top-block__title">ХТО ТАКІ ШУШЛІ МУШЛІ?</h2>
                </div>
                <div class="about__body">
                    <div class="about__text">
                        <p>Бренд [ ШУШЛІ МУШЛІ ] - це більше, ніж просто прикраси. Це унікальні твори мистецтва, створені з любов'ю та майстерністю українських майстрів.</p>

                        <p>
                            У кожному виробі з нашої колекції відчувається щира душа українського народу.<br />
                            Ми використовуємо лише високоякісні матеріали, щоб ваші прикраси дарували вам радість та красу протягом довгих років.
                        </p>

                        <p>
                            Наші прикраси - це не просто аксесуари, це частинка української культури та історії.<br />
                            Вони підкреслять вашу індивідуальність та неповторність, додавши вашому образу вишуканості та елегантності.
                        </p>

                        Ми пропонуємо широкий спектр прикрас ручної роботи та біжутерії:
                        <ul>
                            <li>Сережки: класичні та вишукані, елегантні та пустотливі, з перлами, каменями або без них.</li>
                            <li>Кольє: масивні та мінімалістичні, з ланцюжками або шнурками, з кулонами або без них.</li>
                            <li>Браслети: дизайнерські моделі з ювелірної сталі, з бісеру або каміння, з елементами декору або без них.</li>
                            <li>Анклети: вишукані та оригінальні, з перлами, кулонами або камінчиками.</li>
                            <li>Біжутерія: кольє, браслети, сережки, пташки з різноманітних матеріалів.</li>
                        </ul>
                    </div>
                    <div class="about__image-ibg"><img src="../assets/img/about/01.webp" alt="01.webp" /></div>
                </div>
            </div>
        </section>

        <!--
  <section class="page">
    <div class="page__container">
      <div class="page__body"></div>
    </div>
  </section> -->
    </main>
</template>

<script>
import { Pagination, Autoplay, Navigation, Scrollbar, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import ProductSlider from "./ProductSlider.vue";
import { useHead } from "@vueuse/head";

import "swiper/css";
import "swiper/css/mousewheel";

export default {
    components: {
        Swiper,
        SwiperSlide,
        ProductSlider,
    },
    data() {
        return {
            swiperReviews: {
                breakpoints: {
                    320: {
                        slidesPerView: 2.2,
                        spaceBetween: 15,
                    },
                    767: {
                        slidesPerView: 2.5,
                        spaceBetween: 25,
                    },
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 35,
                    },
                    1270: {
                        slidesPerView: 4,
                        spaceBetween: 50,
                    },
                },
            },
            swiperAdvantages: {
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 15,
                    },
                    767: {
                        slidesPerView: 2.5,
                        spaceBetween: 25,
                    },
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 35,
                    },
                    1270: {
                        slidesPerView: 4,
                        spaceBetween: 50,
                    },
                },
            },
            apiUrl: process.env.VUE_APP_PROD_API_URL,
            productsNewCollection: [],
            produtsSale: [],
            produtsNecklace: [],
            produtsHeels: [],
            produtsEarrings: [],
            produtsQuestionnaires: [],
            banners: [],
            categories: [
                { id: 7, name: "всі прикраси" },
                { id: 2, name: "Кольє" },
                { id: 4, name: "Браслети" },
                { id: 5, name: "Каблучки" },
                { id: 3, name: "Сережки" },
                { id: 8, name: "Кафи" },
                { id: 6, name: "Анклети" },
            ],
            activeCategoryId: 2, // Изначально активная категория
        };
    },
    setup() {
        useHead({
            title: "Shushli-mushli",
            meta: [
                {
                    name: "description",
                    content: "Shusli-mushli - унікальний український бренд прикрас, що народився під час війни, має місію надихати красою і надією. Спеціалізуючись на виготовленні елегантних прикрас з натуральних перлів та дорогоцінного каміння, ми символізуємо внутрішню силу і сяйво душі. Кожен наш виріб - це унікальна історія, втілена в розкішних прикрасах, що пробуджують надію та любов до життя. Відкрийте для себе наш постійно оновлюваний асортимент і персоналізовані прикраси, створені за вашими індивідуальними бажаннями. Shusli-mushli - символ вічної краси та світла у складний час.",
                },
                {
                    property: "og:title",
                    content: "Shushli-mushli – Прикраси з натуральних камінців та перлин",
                },
                {
                    property: "og:description",
                    content: "Shusli-mushli - унікальний український бренд прикрас, що народився під час війни, має місію надихати красою і надією. Спеціалізуючись на виготовленні елегантних прикрас з натуральних перлів та дорогоцінного каміння, ми символізуємо внутрішню силу і сяйво душі. Кожен наш виріб - це унікальна історія, втілена в розкішних прикрасах, що пробуджують надію та любов до життя. Відкрийте для себе наш постійно оновлюваний асортимент і персоналізовані прикраси, створені за вашими індивідуальними бажаннями. Shusli-mushli - символ вічної краси та світла у складний час.",
                },
                {
                    property: "og:image",
                    content: "https://ig.le-perle.com.ua/uploads/logo-og-image.jpg", // URL изображения
                },
                {
                    property: "og:url",
                    content: "https://shushli-mushli.com.ua/", // URL страницы
                },
                {
                    property: "og:type",
                    content: "website",
                },
            ],
        });

        return {
            modules: [Pagination, Autoplay, Navigation, Scrollbar, Mousewheel],
        };
    },
    computed: {
        activeCategoryName() {
            const category = this.categories.find((cat) => cat.id === this.activeCategoryId);
            return category ? category.name : "";
        },
    },

    methods: {
        // async getProductsById(id) {
        //     try {
        //         const res = await this.axios.get(this.apiUrl + "home/products/" + id, {});
        //         return res.data.data;
        //     } catch (error) {
        //         console.error(error);
        //     }
        // },

        // async getProductByCategory() {
        //     this.productsNewCollection = await this.getProductsById(2);
        //     // this.produtsSale = await this.getProductsById(5);
        //     this.produts8march = await this.getProductsById(44);
        //     this.produtsNecklace = await this.getProductsById(3);
        //     this.produtsHeels = await this.getProductsById(4);
        //     this.produtsEarrings = await this.getProductsById(1);
        //     this.produtsQuestionnaires = await this.getProductsById(9);
        // },

        async getBanners() {
            try {
                const response = await this.axios.get(this.apiUrl + "home");
                if (response) {
                    this.banners = response.data;
                }
            } catch (error) {
                console.error(error);
            }
        },
        setActiveCategory(id) {
            this.activeCategoryId = id;
        },
    },

    mounted() {
        // this.getProductByCategory();
        this.getBanners();
    },
};
</script>

<style>
/* Это будет отображаться только на десктопе */
.desktop-only {
    display: block;
}

/* Это будет отображаться только на мобильных устройствах */
.mobile-only {
    display: none;
}

/* Медиа-запрос для мобильных устройств */
@media screen and (max-width: 768px) {
    .desktop-only {
        display: none;
    }
    .mobile-only {
        display: block;
        object-fit: cover;
        width: 100%;
        height: 50vh;
    }
    .hero__body .swiper-slide {
        height: 0;
    }
}
</style>
